/** @format */
import React, { FC, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router'
import styled from 'styled-components'

interface TableSearch {
  className?: string
  syncUrl?: boolean
  children?: React.ReactNode
  style?: React.CSSProperties
  paramsKey?: string
  params?: any
}

export const getURLTableSearchParams = (paramsKey = 'tableSearch') => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const paramsStr = searchParams.get(paramsKey)
  return paramsStr ? JSON.parse(paramsStr) : undefined
}

const DescriptionItem: FC<TableSearch> = ({
  className,
  children,
  style,
  syncUrl = true,
  params,
  paramsKey = 'tableSearch'
}) => {
  const history = useHistory()
  const location = useLocation()
  useEffect(() => {
    if (syncUrl && params) {
      const paramsStr = JSON.stringify(params)
      const searchParams = new URLSearchParams(location.search)
      searchParams.set(paramsKey, paramsStr)
      const newUrl = `${location.pathname}?${searchParams.toString()}`
      history.push(newUrl)
    }
  }, [location, syncUrl, params, paramsKey])

  return (
    <div className={`${className} ksc_table_search`} style={style || {}}>
      {children}
    </div>
  )
}

export default styled(DescriptionItem)<TableSearch>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .search_item {
    display: flex;
    align-items: center;
    margin: 0 16px 16px 0;
    .search_item_label {
      margin: 0px 8px 0 0;
    }
  }
`
